"use strict";
/*
  Readme:
  1. add snackbar: { actionColor: 'black'} to your theme.js
  2. Use NotificationProvider as a child of MuiThemeProvider in your app. Component provides notification context and renders notifications Component
  3. withNotifications HOC provides methods showNotification, showError, showSuccess which publish various notification types
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var actions_1 = require("../../utils/actions");
var NotificationComponent_1 = require("./NotificationComponent");
var c = __importStar(require("../../utils/constants"));
exports.NOTIFICATION_TYPE = {
    SUCCESS: 'success',
    INFO: 'info',
    WARNING: 'warning',
    DANGER: 'danger',
};
var NotificationContext = react_2.createContext();
var getNotificationContext = function () { return react_2.useContext(NotificationContext); };
var notificationReducer = function (state, action) {
    switch (action.type) {
        case c.NOTIFICATION_SEND:
            return __spread(state.filter(function (_a) {
                var id = _a.id;
                return id !== action.payload.id;
            }), [action.payload]);
        case c.NOTIFICATION_DISMISS:
            return state.filter(function (notif) { return notif.id !== action.payload; });
        case c.NOTIFICATION_CLEAR:
            return [];
        default:
            return state;
    }
};
exports.Notifications = function () {
    var _a = getNotificationContext(), notifications = _a.notifications, dispatch = _a.dispatch;
    return notifications.map(function (notification, i) { return (react_1.default.createElement(NotificationComponent_1.Notification, __assign({ key: 'notification' + notification.id }, notification, { index: i, onDismiss: function () { return dispatch({ type: c.NOTIFICATION_DISMISS, payload: notification.id }); } }))); });
};
exports.NotificationProvider = function (_a) {
    var children = _a.children, _b = _a.reducer, reducer = _b === void 0 ? notificationReducer : _b, _c = _a.initialState, initialState = _c === void 0 ? [] : _c;
    var _d = __read(react_2.useReducer(reducer, initialState), 2), notifications = _d[0], dispatch = _d[1];
    return (react_1.default.createElement(NotificationContext.Provider, { value: { notifications: notifications, dispatch: dispatch } },
        react_1.default.createElement(react_1.default.Fragment, null,
            children,
            react_1.default.createElement(exports.Notifications, null))));
};
/**
 * Publish a notification,
 * - if `dismissAfter` was set, the notification will be auto dismissed after the given period.
 */
exports.withNotifications = function (actions) {
    return recompose_1.compose(recompose_1.withProps(function () {
        var dispatch = getNotificationContext().dispatch;
        return {
            addNotification: function (_a) {
                var dismissAfter = _a.dismissAfter, rest = __rest(_a, ["dismissAfter"]);
                var notificationId = new Date().getTime();
                if (dismissAfter) {
                    setTimeout(function () {
                        dispatch(actions_1.notificationDismiss(notificationId));
                    }, dismissAfter);
                }
                dispatch(actions_1.notificationSend(__assign({ id: notificationId }, rest)));
            },
        };
    }), recompose_1.withHandlers({
        showNotification: function (_a) {
            var addNotification = _a.addNotification;
            return function (options) {
                if (options === void 0) { options = { message: 'Notifikace', kind: exports.NOTIFICATION_TYPE.INFO, dismissAfter: 4000 }; }
                return addNotification(options);
            };
        },
        showError: function (_a) {
            var addNotification = _a.addNotification;
            return function (message, dismissAfter) {
                if (message === void 0) { message = 'Akce se neprovedla'; }
                if (dismissAfter === void 0) { dismissAfter = 4000; }
                return addNotification({
                    message: message,
                    kind: exports.NOTIFICATION_TYPE.DANGER,
                    dismissAfter: dismissAfter,
                });
            };
        },
        showSuccess: function (_a) {
            var addNotification = _a.addNotification;
            return function (message, dismissAfter) {
                if (message === void 0) { message = 'Akce byla úspěšne provedena'; }
                if (dismissAfter === void 0) { dismissAfter = 4000; }
                return addNotification({
                    message: message,
                    kind: exports.NOTIFICATION_TYPE.SUCCESS,
                    dismissAfter: dismissAfter,
                });
            };
        },
    }), recompose_1.withProps(function (_a) {
        var e_1, _b, _c;
        var showError = _a.showError, showSuccess = _a.showSuccess;
        if (!lodash_1.isEmpty(actions)) {
            var result = {};
            try {
                for (var _d = __values(Object.keys(actions)), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var actionName = _e.value;
                    result = __assign((_c = {}, _c[actionName + "Notify"] = actions[actionName]({ showError: showError, showSuccess: showSuccess }), _c), result);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return result;
        }
    }));
};
//# sourceMappingURL=Notifications.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/app/Notifications.js
// module id = 536
// module chunks = 0